import { render, staticRenderFns } from "./ResumenPiezas.vue?vue&type=template&id=1b2e8904&"
import script from "./ResumenPiezas.vue?vue&type=script&lang=js&"
export * from "./ResumenPiezas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports